import React, { createContext, useState, useContext, useEffect, useRef } from 'react';
import { useSymphonyApiService } from '../../../hooks/useSymphonyApi';
import { ToastContext } from 'cai-fusion';
import { debugLog } from '../../../configs/loggingConfig';

const IntegrationContext = createContext();

function IntegrationProvider({ children }) {

    const { createToast } = useContext(ToastContext);
    const apiServiceClient = useSymphonyApiService("framework", "v3");

    const [integrations, setIntegrations] = useState([])
    //     {
    //         "id": "1",
    //         "name": "McDonalds",
    //         "description": "Use the power of the new McIntellisense to analyze your cravings!",
    //         "type": "SQL Server",
    //         "status": "Error",
    //         "updatedAt": 1763404174787,
    //         "tools": [
    //             {
    //                 "id": "tag11",
    //                 "title": "Tag A1",
    //                 "description": "do thing",
    //                 "requiresApproval": false,
    //             },
    //             {
    //                 "id": "tag12",
    //                 "title": "Tag B1",
    //                 "description": "do other thing",
    //                 "requiresApproval": true,
    //             },
    //             {
    //                 "id": "tag13",
    //                 "title": "Tag C1",
    //                 "description": "do secret third thing",
    //                 "requiresApproval": true,
    //             },
    //         ]
    //     },
    //     {
    //         "id": "2",
    //         "name": "PetCo",
    //         "description": "We can tell you what your kitty wants.",
    //         "type": "REST API",
    //         "status": "Active",
    //         "updatedAt": 1763404174787,
    //         "tools": [
    //             {
    //                 "id": "tag21",
    //                 "title": "Tag A2",
    //                 "description": "do thing",
    //                 "requiresApproval": false,
    //             },
    //             {
    //                 "id": "tag22",
    //                 "title": "Tag B2",
    //                 "description": "do other thing",
    //                 "requiresApproval": true,
    //             },
    //             {
    //                 "id": "tag23",
    //                 "title": "Tag C2",
    //                 "description": "do secret third thing",
    //                 "requiresApproval": true,
    //             },
    //         ]
    //     },
    //     {
    //         "id": "3",
    //         "name": "Wendy's",
    //         "description": "Dunno what this is, but we serve tenders now.",
    //         "type": "SQL Server",
    //         "status": "Untested",
    //         "updatedAt": 1763604174787,
    //         "tools": [
    //             {
    //                 "id": "tag31",
    //                 "title": "Tag A3",
    //                 "description": "do thing",
    //                 "requiresApproval": false,
    //             },
    //             {
    //                 "id": "tag32",
    //                 "title": "Tag B3",
    //                 "description": "do other thing",
    //                 "requiresApproval": true,
    //             },
    //             {
    //                 "id": "tag33",
    //                 "title": "Tag C3",
    //                 "description": "do secret third thing",
    //                 "requiresApproval": true,
    //             },
    //         ]
    //     },
    //     {
    //         "id": "4",
    //         "name": "MOTEL 6",
    //         "description": "We need an API for our hotel.",
    //         "type": "REST API",
    //         "status": "Error",
    //         "updatedAt": 1763404174787,
    //         "tools": [
    //             {
    //                 "id": "tag41",
    //                 "title": "Tag A4",
    //                 "description": "do thing",
    //                 "requiresApproval": false,
    //             },
    //             {
    //                 "id": "tag42",
    //                 "title": "Tag B4",
    //                 "description": "do other thing",
    //                 "requiresApproval": true,
    //             },
    //             {
    //                 "id": "tag43",
    //                 "title": "Tag C4",
    //                 "description": "do secret third thing",
    //                 "requiresApproval": true,
    //             },
    //         ]
    //     },
    // ])

    const [types, setTypes] = useState([
        {
            "name": "REST API",
            "description": "Connect to any REST API endpoint",
            "id": "HttpApi",
            "fields": [
                {
                    "id": 0,
                    "name": "Name",
                    "description": "The name used to describe the thing being referenced.",
                    "fieldType": "text",
                    "placeholder": "",
                    "value": "",
                    "isRequired": "",
                    "isAdvanced": false,
                },
                {
                    "id": 1,
                    "name": "Big Name",
                    "description": "In case you might have a longer one.",
                    "fieldType": "textarea",
                    "placeholder": "",
                    "value": "",
                    "isRequired": "",
                    "isAdvanced": true,
                }
            ]
        },
        {
            "name": "SQL Server",
            "description": "Connect to SQL servers or Azure SQL databases",
            "id": "Database",
        },
    ])

    const [currTools, setCurrTools] = useState([])

    const [isEditing, setIsEditing] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    // The current integration - blank when creating a new one, deep copy when editing
    const [currIntegration, setCurrIntegration] = useState(undefined);
    // The current configuration - fetched when editing, set manually when creating new
    const [currConfigItem, setCurrConfigItem] = useState(undefined); 

    // Load integrations and configurations when the provider is mounted
    useEffect(() => {
        getIntegrations();
        // getConfigurations();
    }, []);

    // Called when the user presses the edit button on a given integration
    const editIntegration = async (integration) => {

        try {
            let editIntegItem = await apiServiceClient.Integrations.getIntegration(integration.id);  
            
            // Set the current integration to be the one selected.
            setCurrIntegration({...editIntegItem});

            let toolsResp = await apiServiceClient.Integrations.getIntegrationTools(integration.id);
            debugLog.log("[TOOLS] ", toolsResp);
            setCurrTools(toolsResp);

            // Get the configuration information from the backend.
            // let newConfigItem = types.find((type) => type.name === integration.type) ?? {}
            // setCurrConfigItem(JSON.parse(JSON.stringify(newConfigItem))); // replace with api call
            // let getConfigResp = await apiServiceClient.Integrations.getConfiguration(integration.id);
            // Set editing flag
            setIsEditing(true);
        } catch (e) {
            createToast("There was an error getting your integration.", "error")
        }
    }

    // Called when the user presses the "Add Integration" button.
    const newIntegration = () => {
        // Clear integration and config objects.
        setCurrIntegration(undefined);
        setCurrConfigItem(undefined);

        // Set editing flag
        setIsEditing(false);
    }

    const getIntegrations = async () => {
        try {
            let getIntegResp = await apiServiceClient.Integrations.getIntegrations();
            setIntegrations(getIntegResp ?? []);
            debugLog.log("[INTEG] Integrations recieved:", getIntegResp);
        } catch (e) {
            createToast("There was an error fetching integrations.", "error")
        }
    }

    const getConfigurations = async () => {
        try {
            let getConfigResp = await apiServiceClient.Integrations.getConfigurations();
            setTypes(getConfigResp ?? []);
            debugLog.log("[INTEG] Configurations recieved:", getConfigResp);
        } catch (e) {
            createToast("There was an error fetching configurations.", "error");
        }
    }
    
    // Given an integration in the currIntegration state, create one in the list of integrations.
    const createIntegration = async () => {
        // Just in case.
        if (!currIntegration) return; // || !currConfigItem

        try {
            // Create the integration.
            debugLog.log("[INTEG] Initializing integration creation.")
            let createResp = await apiServiceClient.Integrations.createIntegration(currIntegration);
            debugLog.log("[INTEG] Result from create:", createResp)
            // If we have a valid response, add it to the list and reset curr objects.
            if (createResp || true) {
                setIntegrations([...integrations, createResp]);
                createToast("Integration created successfully.", "success");
                setCurrIntegration(undefined);
                setCurrConfigItem(undefined);
            }
        } catch (e) {
            createToast("There was an error creating your integration.", "error");
        } 
    }

    // Given an integration in currIntegration state and a config in the currConfigItem state, update both.
    const updateIntegration = async () => {
        if (!currIntegration) return; // || !currConfigItem

        try {
            // Update the integration first, as it is the simpler object.
            let updateIntegResp = await apiServiceClient.Integrations.updateIntegration(currIntegration.id, currIntegration);
            if (updateIntegResp) {
                // Update the integrations state such that the order is preserved.
                let newIntegrations = [...integrations]
                let updatedInd = newIntegrations.findIndex((integ) => integ.id === updateIntegResp.id)
                newIntegrations[updatedInd] = {...updateIntegResp};
                setIntegrations(newIntegrations);
            }

            // Then, update the configuration.
            // let updateConfigResp = await apiServiceClient.Integrations.updateIntegrationFields(currIntegration.id, currConfigItem);
            // We don't actually need to do anything with this, but we should make sure it's valid.
            // if (updateConfigResp) {
                // In here, clear all current fields and display success toast.
                // createToast("Integration updated successfully.", "success")
                // setCurrIntegration(undefined);
                // setCurrConfigItem(undefined);
            // }
        } catch (e) {
            createToast("There was an error updating your integration.", "error")
        }
    }

    // Given an already selected integration, delete it.
    // This integration is already in the currIntegration state.
    const deleteIntegration = async () => {
        if (!currIntegration) return; 

        try {
            // Visually remove the integration only if the API call succeeds first.
            await apiServiceClient.Integrations.deleteIntegration(currIntegration.id);
            setIntegrations([...integrations.filter((integration) => integration.id !== currIntegration.id)])
        } catch (e) {
            createToast("There was an error deleting your integration.", "error")
        } finally {
            // Make sure curr is cleared regardless.
            setCurrIntegration(undefined);
        }
    }

    // Given a tool object, add it to the current integration.
    const createTool = async (toolObj) => {
        if (!currIntegration) return;

        try {
            //debugLog.log("[INTEGRATIONS] Tool Obj: ", {...toolObj, "id": ""})
            let toolCreateResp = await apiServiceClient.Integrations.createIntegrationTool(currIntegration.id, {...toolObj, "id": "00000000-0000-0000-0000-000000000000", "integrationId": currIntegration.id});
            // Update the current tool list
            setCurrTools([...currTools, toolCreateResp]);
        } catch (e) {
            createToast("There was an error creating your integration tool.", "error")
        }
    }

    // Given a tool object, use its ID to update the current integration.
    const updateTool = async (toolObj) => {
        if (!currIntegration) return;

        try {
            let updatedToolResp = await apiServiceClient.Integrations.updateIntegrationTool(currIntegration.id, toolObj.id, toolObj);
            // Update current integration's tools
            let newTools = [...currTools]
            let newToolsInd = newTools.findIndex((tool) => tool.id === updatedToolResp.id);
            newTools[newToolsInd] = updatedToolResp
            setCurrTools([...newTools])
            debugLog.log(newToolsInd, newTools);
        } catch (e) {
            createToast("There was an error updating your integration tool.", "error")
        }
    }

    // Given a tool ID, delete it from the current integration.
    const deleteTool = async (toolId) => {
        if (!currIntegration) return;

        try {
            await apiServiceClient.Integrations.deleteIntegrationTool(currIntegration.id, toolId);
            // Update the current integration
            let newTools = [...currTools]
            newTools = newTools.filter((tool) => tool.id !== toolId)
            setCurrTools([...newTools])
        } catch (e) {
            createToast("There was an error deleting your integration tool.", "error")
        }
    }

    return (
        <IntegrationContext.Provider value={{
            // States
            integrations,
            types,
            isEditing,
            setIsEditing,
            isLoading,
            currIntegration,
            setCurrIntegration,
            currConfigItem,
            setCurrConfigItem,
            currTools,
            setCurrTools,
            // Functions
            newIntegration,
            editIntegration,
            getIntegrations,
            getConfigurations,
            createIntegration,
            updateIntegration,
            deleteIntegration,
            createTool,
            updateTool,
            deleteTool,
        }}>
            {children}
        </IntegrationContext.Provider>
    );
}

function useIntegration() {
    const context = useContext(IntegrationContext);
    if (context === undefined) {
        throw new Error('useIntegration must be used within a IntegrationProvider');
    }
    return context;
}

export { IntegrationProvider, useIntegration };